import React from "react";
import {
  Card,
  Box,
  Typography,
  Select,
  MenuItem,
  FormControl,
} from "@mui/material";
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
} from "recharts";

const LeadsBySourceChart = ({
  data,
}: {
  data: { name: string; value: number }[];
}) => {
  const COLORS = ["#3B82F6", "#22C55E", "#FACC15"];

  const renderCustomizedLabel = ({ percent }: any) =>
    `${(percent * 100).toFixed(0)}%`;

  return (
    <Card
      sx={{
        p: 2,
        borderRadius: 3,
        boxShadow: "none",
      }}
    >
      {/* Header */}
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
        <Typography fontWeight={600} fontSize={14}>
          Leads By Source
        </Typography>
        <Box
          sx={{
            backgroundColor: "#3B82F6",
            color: "#fff",
            borderRadius: "16px",
            px: 1.5,
            py: 0.3,
            fontSize: 12,
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
          }}
        >
          Monthly ▼
        </Box>
      </Box>

      {/* Chart */}
      <Box display="flex" justifyContent="center" alignItems="center">
        <ResponsiveContainer width="70%" height={220}>
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              labelLine={false}
              label={renderCustomizedLabel}
              outerRadius={80}
              dataKey="value"
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </Box>

      {/* Legend */}
      <Box
        mt={2}
        display="flex"
        justifyContent="center"
        alignItems="center"
        gap={4}
      >
        {data.map((entry, index) => (
          <Box
            key={entry.name}
            display="flex"
            alignItems="center"
            gap={1}
            sx={{ color: "text.secondary" }}
          >
            <Box
              sx={{
                width: 14,
                height: 14,
                borderRadius: "4px",
                backgroundColor: COLORS[index],
              }}
            />
            <Typography fontSize={13}>{entry.name}</Typography>
          </Box>
        ))}
      </Box>
    </Card>
  );
};

export default LeadsBySourceChart;
